import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=350aa903&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports